<!-- <template>
  <div>
    <div v-if="status && profileData">
      <div class="dovemed-card">
        <div class="heading-icon">
          <div class="title d-inline-block ">
            ABOUT {{ getUserName | humanize() }}
          </div>
          <span
            @click="() => $refs.basicDetailsModal.show(profileData, fetchData)"
            class="edit-icon cp font-white "
            :style="{ background: `${getPrimaryColor()}` }"
          >
            <a-icon type="edit" class="d-flex align-items-center" />Edit
          </span>
        </div>
        <p v-if="authUser.user.role === 'patient'">
          <span class="text-capitalize">{{ authUser.user.display_name }}</span>
          is living with
          {{ profileData["disease_type"] }}
          <span v-if="profileData['diagnosis_date']"
            >for the past {{ getDiagnosisDate }}.</span
          >
        </p>
        <p v-if="authUser.user.role === 'caregiver'">
          <span class="text-capitalize">{{ authUser.user.display_name }}</span>
          is taking care of a patient of
          <b>{{ getDOB }} years</b>

          living with a condition {{ profileData["disease_type"] }}.
        </p>
        <div class="mb-3">
          <b>Other conditions </b>:
          {{ otherPatientConditions[0] || "Yet to be added" }}
          <div
            @click="handleGoToConditions"
            v-if="otherPatientConditions.length > 1"
            :style="{ display: 'inline-block', color: getPrimaryColor() }"
          >
            and
            {{ otherPatientConditions.length - 1 }} more
          </div>
        </div>


        <p><b> Diagnosis Date </b>: {{ profileData["diagnosis_date"] }}</p>
        <p>
          <b>Gender </b>:
          {{ profileData["gender"] === "male" ? "Male" : "Female" }}
        </p>



        <p class="text-capitalize">
          <b>{{ "Gender" | humanize(false) }} </b>:
          {{
            profileData["gender"] === "other" ? "Others" : profileData["gender"]
          }}
        </p>
        <p>
          <b>{{ "current_work_situation" | humanize(false) }} </b>:
          {{ profileData["current_situation"] || "Yet to be added" }}
        </p>
        <p :style="{ 'text-transform': 'capitalize' }">
          <b>{{ "relationship_status" | humanize(false) }} </b>:
          {{ profileData["relationship_status"] || "Yet to be added" }}
        </p>
        <p class="patient-interests ">
          <b>{{ "interests" | humanize(false) }} </b>:
          <span v-for="i in profileData['interests']" :key="i">
            {{ i }}
          </span>
        </p>
        <div style="display: flex">
          <p>
            <b style="min-width: 60px">Mini Bio </b>:

            {{
              profileData["mini_bio"]
                ? profileData["mini_bio"] || "Yet to be added"
                : profileData["story"] || "Yet to be added"
            }}
          </p>
        </div>
      </div>
      <div v-for="(cardValue, cardKey, index) in cardKeys" :key="index">
        <div v-if="cardKey === 'symptom'" class="dovemed-card">
          <div class="heading-icon">
            <div class="title d-inline-block text-uppercase">
              SYMPTOMS RELATED TO {{ currentCircle.condition_type }} ({{
                profileData[cardKey] ? profileData[cardKey].length : "0"
              }})
            </div>
            <span
              @click="
                () => $refs.symptomsModal.show(cardKey, [], [], fetchData)
              "
              v-if="!cardValue"
              class="edit-icon cp font-white "
              :style="{ background: getPrimaryColor() }"
            >
              <a-icon
                class="d-flex align-items-center font-white"
                type="edit"
              />
              <div>Edit</div>
            </span>
          </div>
          <div v-if="profileData[cardKey].length > 0">
            <div
              class="d-flex display-symptom mt-2"
              v-for="(symptom, index) in profileData[cardKey]"
              :key="index"
            >
              <b>
                {{ symptom.display_name }}
              </b>
              <div
                :style="{
                  color: getEffectivenessColor(symptom.effectiveness),
                  background: `${getEffectivenessColor(
                    symptom.effectiveness
                  )}25`,
                  padding: '2px 5px',
                  'min-width': '100px',
                  'border-radius': '5px',
                  display: 'flex',
                  'justify-content': 'center'
                }"
              >
                {{ getEffectiveness(symptom.effectiveness) }}
              </div>
            </div>
          </div>
          <div v-else class="none-section">
            You haven’t added any symptoms yet. Add symptoms to increase your
            profile visibility.
          </div>
        </div>
        <div
          id="other_conditions"
          v-if="cardKey === 'other_symptom'"
          class="dovemed-card d-flex flex-column "
        >
          <div class="heading-icon" :style="{ 'flex-direction': 'column' }">
            <div class="d-flex ">
              <div class="title d-inline-block ">
                OTHER DIAGNOSED CONDITIONS ({{ otherPatientConditions.length }})
                AND SYMPTOMS ({{
                  profileData[cardKey] ? profileData[cardKey].length : 0
                }})
              </div>
              <span
                @click="
                  () =>
                    $refs.otherSymptomsModal.show(cardKey, [], [], fetchData)
                "
                v-if="!cardValue"
                class="edit-icon cp font-white "
                :style="{ background: getPrimaryColor() }"
              >
                <a-icon
                  class="d-flex align-items-center font-white"
                  type="edit"
                />Edit
              </span>
            </div>
            <div
              class="title d-inline-block "
              :style="{ color: 'rgba(51,51,51,0.38)', 'font-size': '12px' }"
            >
              (Conditions that have been diagnosed by a healthcare professional)
            </div>
          </div>
          <div>



            <ul>
              <li v-for="(item, index) in profileData[cardKey]" :key="index">
                {{ authUser.user.display_name }} has {{ item.circle_name }} with
                {{ getEffectiveness(item.effectiveness) }}
                {{ item.display_name }} as a condition.
              </li>
            </ul>



            <div v-if="profileData[cardKey].length > 0">
              <div
                class="d-flex display-symptom mt-2 flex-column"
                v-for="(item, index) in otherPatientConditions"
                :key="index"
              >
                <div v-if="item" class="d-flex flex-column align-items-start">
                  <b>
                    {{ item }}
                  </b>

                  <div :style="{ display: 'flex', 'flex-wrap': 'wrap' }">
                    <div class="d-flex align-items-center">Symptoms :</div>
                    <div
                      v-for="(symptom, index) in profileData[cardKey]"
                      :key="index"
                    >
                      <div
                        v-if="item === symptom.circle_name"
                        :style="{
                          color: getEffectivenessColor(symptom.effectiveness),
                          background: `${getEffectivenessColor(
                            symptom.effectiveness
                          )}25`,
                          padding: '2px 5px',
                          'min-width': '100px',
                          'border-radius': '5px',
                          width: 'fit-content',
                          display: 'flex',
                          'justify-content': 'center',
                          margin: '10px'
                        }"
                      >
                        <div class="pr-3" :style="{ color: '#333333' }">
                          {{ symptom.display_name }}
                        </div>
                        <div class="font-weight-bold">
                          {{ getEffectiveness(symptom.effectiveness) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="none-section">
              You haven’t added other diagnosed conditions. Add them to increase
              your profile visibility.
            </div>
          </div>
        </div>

        <div v-if="cardKey === 'treatment'" class="dovemed-card">
          <div class="heading-icon">
            <div class="title d-inline-block ">
              TYPES OF TREATMENTS AND PROCEDURES
              {{ profileData[cardKey] | total }}
            </div>
            <span
              @click="$router.push({ name: 'PatientTreatments' })"
              v-if="!cardValue"
              class="edit-icon cp font-white "
              :style="{ background: getPrimaryColor() }"
            >
              <a-icon
                class="d-flex align-items-center font-white"
                type="edit"
              />Edit
            </span>
          </div>
          <div>
            <div v-if="'Medication' in groupedTreatments">
              <div
                :style="{ 'font-size': '16px' }"
                class="font-weight-bold mb-2"
              >
                Medication
              </div>
              <div
                v-if="'Medication' in groupedTreatments"
                class="user-treatment"
              >
                <ul>
                  <li
                    v-for="treatment in groupedTreatments.Medication"
                    :key="treatment.id"
                    class="display-symptom text-capitalize mb-2 d-flex font-weight-bold"
                  >
                    {{ treatment.treatment[0].display_name }}
                    <div class="d-flex">
                      <div
                        class="treatment-eff"
                        :style="{
                          color: getTreatEffectivenessColor(
                            treatment.effectiveness
                          ),
                          background: `${getTreatEffectivenessColor(
                            treatment.effectiveness
                          )}25`,
                          padding: '2px 5px',
                          'min-width': '100px',
                          'border-radius': '5px',
                          height: 'fit-content',
                          width: 'fit-content',
                          display: 'flex',
                          'margin-right': '10px',
                          'justify-content': 'center'
                        }"
                      >
                        {{ getTreatEffectiveness(treatment.effectiveness) }}
                      </div>
                      <span
                        @click="removeTreatment(treatment.id)"
                        class="icon  cp"
                      >
                        <font-awesome-icon
                          size="2x"
                          :style="{
                            color: '#fa5c5c',

                            transform: 'scale(0.6)',
                            'margin-left': '5px'
                          }"
                          :icon="['fas', 'trash']"
                        />
                      </span>
                    </div>
                  </li>
                </ul>
              </div>
              <div v-else class="none-section">No Medications listed.</div>
            </div>

            <div v-if="'Procedure' in groupedTreatments">
              <div
                :style="{ 'font-size': '16px' }"
                class="font-weight-bold mb-2"
              >
                Procedure
              </div>
              <div
                v-if="'Procedure' in groupedTreatments"
                class="user-treatment"
              >
                <ul>
                  <li
                    v-for="treatment in groupedTreatments.Procedure"
                    :key="treatment.id"
                    class="display-symptom text-capitalize mb-2 d-flex font-weight-bold"
                  >
                    <div class="profile-sub">
                      <div>{{ treatment.treatment[0].display_name }}</div>
                      <span v-if="treatment.treatment[0].sub_type">
                        (
                        <span
                          v-for="(sub, index) in treatment.treatment[0]
                            .sub_type"
                          :key="index"
                        >
                          {{ sub }}
                        </span>
                        )
                      </span>
                    </div>
                    <div class="d-flex">
                      <div
                        class="treatment-eff"
                        :style="{
                          color: getTreatEffectivenessColor(
                            treatment.effectiveness
                          ),
                          background: `${getTreatEffectivenessColor(
                            treatment.effectiveness
                          )}25`,
                          padding: '2px 5px',
                          'min-width': '100px',
                          'border-radius': '5px',
                          height: 'fit-content',
                          width: 'fit-content',
                          display: 'flex',
                          'margin-right': '10px',
                          'justify-content': 'center'
                        }"
                      >
                        {{ getTreatEffectiveness(treatment.effectiveness) }}
                      </div>
                      <span
                        @click="removeTreatment(treatment.id)"
                        class="icon  cp"
                      >
                        <font-awesome-icon
                          size="2x"
                          :style="{
                            color: '#fa5c5c',

                            transform: 'scale(0.6)',
                            'margin-left': '5px'
                          }"
                          :icon="['fas', 'trash']"
                        />
                      </span>
                    </div>
                  </li>
                </ul>
              </div>
              <div v-else class="none-section">No Procedures listed.</div>
            </div>

            <div v-if="'Activity' in groupedTreatments">
              <div
                :style="{ 'font-size': '16px' }"
                class="font-weight-bold mb-2"
              >
                Activity
              </div>
              <div
                v-if="'Activity' in groupedTreatments"
                class="user-treatment"
              >
                <ul>
                  <li
                    v-for="treatment in groupedTreatments.Activity"
                    :key="treatment.id"
                    class="display-symptom text-capitalize mb-2 d-flex font-weight-bold"
                  >
                    {{ treatment.treatment[0].display_name }}

                    <div class="d-flex">
                      <div
                        class="treatment-eff"
                        :style="{
                          color: getTreatEffectivenessColor(
                            treatment.effectiveness
                          ),
                          background: `${getTreatEffectivenessColor(
                            treatment.effectiveness
                          )}25`,
                          padding: '2px 5px',
                          'min-width': '100px',
                          height: 'fit-content',
                          'border-radius': '5px',
                          width: 'fit-content',
                          display: 'flex',
                          'margin-right': '10px',
                          'justify-content': 'center'
                        }"
                      >
                        {{ getTreatEffectiveness(treatment.effectiveness) }}
                      </div>
                      <span
                        @click="removeTreatment(treatment.id)"
                        class="icon  cp"
                      >
                        <font-awesome-icon
                          size="2x"
                          :style="{
                            color: '#fa5c5c',
                            transform: 'scale(0.6)',
                            'margin-left': '5px'
                          }"
                          :icon="['fas', 'trash']"
                        />
                      </span>
                    </div>
                  </li>
                </ul>
              </div>
              <div v-else class="none-section">No activities listed.</div>
            </div>
          </div>
        </div>

        <div v-if="cardKey === 'most_days_i_find_myself'" class="dovemed-card">
          <div class="heading-icon">
            <div class="title d-inline-block ">
              {{ cardKey | humanize }}
            </div>
            <span
              @click="
                () =>
                  $refs.editBasicTextModal.show(cardKey, profileData[cardKey])
              "
              v-if="!cardValue"
              class="edit-icon cp font-white "
              :style="{ background: getPrimaryColor() }"
            >
              <a-icon type="edit" class="d-flex align-items-center" />Edit
            </span>
          </div>
          <div
            v-if="profileData[cardKey]"
            style="white-space: pre-wrap; overflow: auto; word-break: break-all"
          >
            {{ profileData["most_days_i_find_myself"] }}
          </div>
          <div v-else class="none-section">You haven’t responded yet.</div>
        </div>
        <div
          v-if="cardKey === 'my_life_has_changed_in_this_way'"
          class="dovemed-card"
        >
          <div class="heading-icon">
            <div class="title d-inline-block ">
              {{ cardKey | humanize }}
            </div>
            <span
              @click="
                () =>
                  $refs.editBasicTextModal.show(cardKey, profileData[cardKey])
              "
              v-if="!cardValue"
              class="edit-icon cp font-white "
              :style="{ background: getPrimaryColor() }"
            >
              <a-icon type="edit" class="d-flex align-items-center" />Edit
            </span>
          </div>
          <div
            v-if="profileData[cardKey]"
            style="white-space: pre-wrap; overflow: auto; word-break: break-all"
          >
            {{ profileData["my_life_has_changed_in_this_way"] }}
          </div>
          <div v-else class="none-section">You haven’t responded yet.</div>
        </div>

        <div v-if="cardKey === 'when_im_having_a_bad_day'" class="dovemed-card">
          <div class="heading-icon">
            <div class="title d-inline-block ">
              {{ "when_i_am_having_a_bad_day" | humanize }}
            </div>
            <span
              @click="
                () =>
                  $refs.editBasicTextModal.show(cardKey, profileData[cardKey])
              "
              v-if="!cardValue"
              class="edit-icon cp font-white "
              :style="{ background: getPrimaryColor() }"
            >
              <a-icon type="edit" class="d-flex align-items-center" />Edit
            </span>
          </div>
          <div
            v-if="profileData[cardKey]"
            style="white-space: pre-wrap; overflow: auto; word-break: break-all"
          >
            {{ profileData["when_im_having_a_bad_day"] }}
          </div>
          <div v-else class="none-section">You haven’t responded yet.</div>
        </div>

        <div v-if="cardKey === 'given_what_i_know_now'" class="dovemed-card">
          <div class="heading-icon">
            <div class="title d-inline-block ">
              {{ cardKey | humanize }}
            </div>
            <span
              @click="
                () =>
                  $refs.editBasicTextModal.show(cardKey, profileData[cardKey])
              "
              v-if="!cardValue"
              class="edit-icon cp font-white "
              :style="{ background: getPrimaryColor() }"
            >
              <a-icon type="edit" class="d-flex align-items-center" />
              <div>Edit</div>
            </span>
          </div>
          <div
            v-if="profileData[cardKey]"
            style="white-space: pre-wrap; overflow: auto; word-break: break-all"
          >
            {{ profileData["given_what_i_know_now"] }}
          </div>
          <div v-else class="none-section">You haven’t responded yet.</div>
        </div>
      </div>
      <div class="dovemed-card">
        <div class="heading-icon" :style="{ 'flex-direction': 'column' }">
          <div class="d-flex ">
            <div class="title d-inline-block ">
              {{ "additional conditions" | humanize }}
              {{ profileData["add_conditions"] | total }}
            </div>
            <span
              @click="
                () =>
                  $refs.additionalConditionsModal.show(
                    'add_conditions',
                    profileData['add_conditions'],
                    [],
                    fetchData
                  )
              "
              class="edit-icon cp font-white "
              :style="{ background: getPrimaryColor() }"
            >
              <div>
                <a-icon type="edit" class="d-flex align-items-center" />
              </div>
              <div>Edit</div>
            </span>
          </div>
          <div
            class="title d-inline-block "
            :style="{ color: 'rgba(51,51,51,0.38)', 'font-size': '12px' }"
          >
            (Conditions that hasn’t been diagnosed by a healthcare professional)
          </div>
        </div>

        <div v-if="profileData['add_conditions'].length > 0">
          <div
            class="d-flex display-symptom mt-2 flex-column"
            v-for="(item, index) in additionalConditions"
            :key="index"
          >
            <div v-if="item" class="d-flex flex-column align-items-start">
              <b>
                {{ item }}
              </b>

              <div :style="{ display: 'flex', 'flex-wrap': 'wrap' }">
                <div class="d-flex align-items-center">Symptoms :</div>
                <div
                  v-for="(symptom, index) in profileData['add_conditions']"
                  :key="index"
                >
                  <div
                    v-if="item === symptom.circle_name"
                    :style="{
                      color: getEffectivenessColor(symptom.effectiveness),
                      background: `${getEffectivenessColor(
                        symptom.effectiveness
                      )}25`,
                      padding: '2px 5px',
                      'min-width': '100px',
                      'border-radius': '5px',
                      width: 'fit-content',
                      display: 'flex',
                      'justify-content': 'center',
                      margin: '10px'
                    }"
                  >
                    <div class="pr-3" :style="{ color: '#333333' }">
                      {{ symptom.display_name }}
                    </div>
                    <div class="font-weight-bold">
                      {{ getEffectiveness(symptom.effectiveness) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="none-section">You haven’t responded yet.</div>
      </div>
    </div>
    <BasicTextModal ref="editBasicTextModal" v-on:refresh="fetchData" />
    <AdditionalConditionsModal
      ref="additionalConditionsModal"
      v-on:refresh="fetchData"
    />
    <BasicDetailsModal ref="basicDetailsModal" v-on:refresh="fetchData" />
    <SymptomsModal
      ref="symptomsModal"
      v-on:refresh="fetchData"
      :forceRender="forceRender"
    />
    <OtherSumptomsModal ref="otherSymptomsModal" v-on:refresh="fetchData" />
    <TreatmentModal ref="treatmentModal" v-on:refresh="fetchData" />
  </div>
</template> -->
<template>
  <div class="w-100">
    <div v-if="fetchingData" class="d-flex justify-content-center">
      <div class="spinner-border position-absolute spinner-class"></div>
    </div>
    <div class="stry-cont" v-if="profileData && !fetchingData">
      <div class="abt-container">
        <div class="header-cont">
          <span class="header">
            About <span class="text-capitalize">{{ getUserName }}</span>
          </span>
          <span :style="{ background: getPrimary50Color() }" class="edit-button" @click="() => $refs.basicDetailsModal.show(profileData, fetchData)">
            <font-awesome-icon size="1x" :style="{ color: getAlphaPrimaryColor50() }" :icon="['fas', 'pen']" />
            <span :style="{ color: getPrimaryColor() }" class="button-text"> Edit</span>
          </span>
        </div>
        <div class="abt-2-cont">
          <span v-if="authUser.user.role === 'patient'" class="intro">
            <span class="name text-capitalize">
              {{ authUser.user.display_name ? authUser.user.display_name : "nodisplayname" }}
            </span>
            is living with {{ profileData["disease_type"] || currentCircle.condition_type }}
            <span v-if="profileData['diagnosis_date']"> since {{ getDiagnosedYear }}.</span>
            <!-- <span v-if="profileData['diagnosis_date']"> for the past {{ getDiagnosisDate }}.</span> -->
          </span>
          <span v-if="authUser.user.role === 'caregiver' && profileData && profileData['diagnosis_date']" class="intro">
            <span class="name text-capitalize">{{ authUser.user.display_name || "D" }}</span>
            <!-- is taking care of a patient of {{ getDiagnosisDate }} living with a condition {{ profileData["disease_type"] }}. -->
            is taking care of a patient who is living with the condition {{ profileData["disease_type"] }} for about {{ getDiagnosisDate }}.
            <!-- is taking care of a patient of {{ getDOB }} years living with a condition {{ profileData["disease_type"] }}. -->
          </span>
          <div class="general-info">
            <div class="info-cont">
              <span class="name">Gender</span>
              <span v-if="profileData['gender']" class="intro text-capitalize">
                {{ profileData["gender"] }}
              </span>
              <span v-else class="dailog1">None added</span>
            </div>
            <div class="vertical-seperator"></div>
            <div class="info-cont">
              <span class="name">Current Work Situation</span>
              <span v-if="profileData['current_situation']" class="intro">{{ profileData["current_situation"] }}</span>
              <span v-else class="dailog1">None added</span>
            </div>
            <div class="vertical-seperator"></div>
            <div class="info-cont">
              <span class="name">Relationship Status</span>
              <span v-if="profileData['relationship_status']" class="intro text-capitalize">{{ profileData["relationship_status"] }}</span>
              <span v-else class="dailog1">None added</span>
            </div>
          </div>
          <div class="interest">
            <span class="name">{{ "Interests" | humanize(false) }}</span>
            <div class="intrst-cont" v-if="profileData['interests'] && profileData['interests'].length">
              <span class="intrst" v-for="i in profileData['interests']" :key="i">
                {{ i }}
              </span>
            </div>
            <div class="top" v-else>
              <span class="dailog">None added</span>
            </div>
          </div>
          <div class="minibio">
            <span class="name">Mini Bio</span>
            <span v-if="profileData['mini_bio'] || profileData['story']" class="bio">{{ profileData["mini_bio"] || profileData["story"] }}</span>
            <div class="top" v-else>
              <span class="dailog">You haven’t added anything. Help others know who you are.</span>
            </div>
          </div>
        </div>

        <!-- <div v-if="fetchingData" class="d-flex justify-content-center m-auto">
          <div>
            <div class="spinner-border position-absolute spinner-class"></div>
          </div>
          <div :style="{ 'margin-left': '-14px', 'margin-top': '40px' }">Loading...</div>
        </div> -->

        <!-- symptoms -->

        <div id="firstloop" :style="{ width: '100%' }" v-for="(cardValue, cardKey, index) in cardKeys" :key="index">
          <div v-if="cardKey === 'symptom'" class="symptoms">
            <div class="header-cont">
              <span class="header">Symptoms related to {{ currentCircle.condition_type }}</span>
              <span @click="() => $refs.symptomsModal.show([], [], fetchData, cardKey)" v-if="!cardValue" :style="{ background: getPrimary50Color() }" class="edit-button">
                <font-awesome-icon size="1x" :style="{ color: getAlphaPrimaryColor50() }" :icon="['fas', 'plus']" />
                <span :style="{ color: getPrimaryColor() }" class="button-text">Add</span>
              </span>
            </div>
            <div v-if="profileData[cardKey] && profileData[cardKey].length" class="symptomsgrid">
              <div v-for="(symptom, index) in profileData[cardKey]" :key="index" class="grid-item">
                <div class="info-cont">
                  <span class="name">{{ symptom.display_name }}</span>
                  <span
                    :style="{
                      color: getEffectivenessColor(symptom.effectiveness),
                      background: `${getEffectivenessColor(symptom.effectiveness)}25`,
                      padding: '2px 5px',
                      'min-width': '100px',
                      'border-radius': '5px',
                      display: 'flex',
                      'justify-content': 'center',
                    }"
                  >
                    {{ getEffectiveness(symptom.effectiveness) }}
                  </span>
                </div>
                <div @click="deleteClick('Symptom', symptom.display_name)" class="dlt">
                  <!-- <div @click="handleSymDel(symptom.display_name)" class="dlt"> -->
                  <font-awesome-icon size="1x" :style="{ color: '#FF9999' }" :icon="['fas', 'trash']" />
                  Delete
                </div>
              </div>
            </div>
            <div v-else class="dailog">You haven’t added any symptoms yet. Add symptoms to increase your profile visibility.</div>
          </div>
        </div>

        <!-- other diagnosed condition -->

        <!-- <div id="2loop" :style="{ width: '100%' }" v-for="(cardValue, cardKey, index) in cardKeys" :key="index">
          <div v-if="cardKey === 'other_symptom'" class="symptoms">
            <div class="cont">
              <div class="header-cont">
                <span class="header">Other Diagnosed Conditions and Symptoms</span>
                <span :style="{ background: getPrimary50Color() }" class="edit-button" @click="() => $refs.otherSymptomsModal.show(cardKey, [], [], fetchData)" v-if="!cardValue">
                  <font-awesome-icon size="1x" :style="{ color: getAlphaPrimaryColor50() }" :icon="['fas', 'plus']" />
                  <span :style="{ color: getPrimaryColor() }" class="button-text">Add</span>
                </span>
              </div>
              <span class="bio">(Conditions that have been diagnosed by a healthcare professional)</span>
            </div>
            <div class="top" v-if="profileData['other_symptom'] && profileData['other_symptom'].length">
              <div v-for="(item, index) in otherPatientConditions" :key="index" class="other-condition">
                <div class="other-cond-header">
                  <span v-if="item" class="header-cond">{{ item }}</span>
                  <div class="btns">
                    <span @click="() => $refs.otherSymptomedit.show(cardKey, [], [], fetchData, item, profileData[cardKey])" class="edit-button">
                      <font-awesome-icon size="1x" :style="{ color: getAlphaPrimaryColor50() }" :icon="['fas', 'pen']" />
                      <span :style="{ color: getPrimaryColor() }" class="button-text">Edit</span>
                    </span>
                    <div @click="deleteClick('Other Condition', item)" class="dlt-inner">
                      <font-awesome-icon size="1x" :style="{ color: '#FF9999' }" :icon="['fas', 'trash']" />
                      Delete
                    </div>
                  </div>
                </div>
                <div class="symp-cont">
                  <span class="name">Symptoms:</span>
                  <div class="symptomsgrid">
                    <div v-for="(symptom, index) in profileData[cardKey]" :key="index" v-if="symptom.circle_name === item" class="grid-item">
                      <div class="info-cont">
                        <span class="name"> {{ symptom.display_name }}</span>
                        <span
                          class="rounded fw700 font12 d-flex px-2 py-1 justify-content-center"
                          :style="{ color: getEffectivenessColor(symptom.effectiveness), background: `${getEffectivenessColor(symptom.effectiveness)}25`, 'line-height': '14px', width: 'fit-content' }"
                        >
                          {{ getEffectiveness(symptom.effectiveness) }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="btns-mob">
                  <span @click="() => $refs.otherSymptomedit.show(cardKey, [], [], fetchData, item, profileData[cardKey])" class="edit-button">
                    <font-awesome-icon size="1x" :style="{ color: getAlphaPrimaryColor50() }" :icon="['fas', 'pen']" />
                    <span :style="{ color: getPrimaryColor() }" class="button-text">Edit</span>
                  </span>
                  <div @click="deleteClick('Other Condition', item)" class="dlt-inner">
                    <font-awesome-icon size="1x" :style="{ color: '#FF9999' }" :icon="['fas', 'trash']" />
                    Delete
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="dailog">You haven’t added other diagnosed conditions. Add them to increase your profile visibility.</div>
          </div>
        </div> -->

        <SimpleLoader :name="'other diagnosed conditions'" v-if="!fetchingData && otherCondnLoading" class="mx-auto" />

        <!-- <div id="2loop" :style="{ width: '100%' }" v-for="(cardValue, cardKey, index) in cardKeys" :key="index">
          <div v-if="cardKey === 'other_symptom'" class="symptoms align-items-stretch"> -->
        <div id="2loop" :style="{ width: '100%' }">
          <div class="symptoms align-items-stretch">
            <div class="cont">
              <div class="header-cont">
                <span class="header">Other Diagnosed Conditions and Symptoms</span>
                <span :style="{ background: getPrimary50Color() }" class="edit-button" @click="() => $refs.otherSymptomsModal.show('other_symptom', [], [], fetchOtherCondns)" v-if="!cardValue">
                  <font-awesome-icon size="1x" :style="{ color: getAlphaPrimaryColor50() }" :icon="['fas', 'plus']" />
                  <span :style="{ color: getPrimaryColor() }" class="button-text">Add</span>
                </span>
              </div>
              <span class="bio">(Conditions that have been diagnosed by a healthcare professional)</span>
            </div>
            <div class="top" v-if="otherConditionsList && otherConditionsList.length">
              <div v-for="item in otherConditionsList" :key="item" class="other-condition">
                <div class="other-cond-header">
                  <span v-if="item" class="header-cond">{{ item.othercondition_details.display_name || "" }}</span>
                  <div class="btns">
                    <span @click="() => $refs.otherSymptomedit.show('other_symptom', [], [], fetchOtherCondns, item, profileData['other_symptom'])" class="edit-button">
                      <font-awesome-icon size="1x" :style="{ color: getAlphaPrimaryColor50() }" :icon="['fas', 'pen']" />
                      <span :style="{ color: getPrimaryColor() }" class="button-text">Edit</span>
                    </span>
                    <div @click="deleteClick('Other Condition', item)" class="dlt-inner">
                      <font-awesome-icon size="1x" :style="{ color: '#FF9999' }" :icon="['fas', 'trash']" />
                      Delete
                    </div>
                  </div>
                </div>
                <div class="symp-cont" v-if="item.symptom && item.symptom.length">
                  <span class="name">Symptoms:</span>
                  <div class="symptomsgrid">
                    <div v-for="symptom in item.symptom" :key="symptom" class="grid-item">
                      <div class="info-cont">
                        <span class="name"> {{ symptom.symptom_details.display_name }}</span>
                        <span
                          class="rounded fw700 font12 d-flex px-2 py-1 justify-content-center"
                          :style="{ color: getEffectivenessColor(symptom.effectiveness), background: `${getEffectivenessColor(symptom.effectiveness)}25`, 'line-height': '14px', width: 'fit-content' }"
                        >
                          {{ getEffectiveness(symptom.effectiveness) }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mt-3 w-100" v-for="eachTreatment in treatmentTypes" :key="eachTreatment">
                  <div class="mb-3 d-flex justify-content-between">
                    <p class="mb-0 gray900 fw700 font16">{{ eachTreatment }}:</p>
                    <p class="mb-0 d-flex align-items-center font14 fw700 cp" :style="{ color: getPrimaryColor() }" @click="handleAddTreatmentType(eachTreatment, 'add', {}, item.id)">
                      <font-awesome-icon :style="{ color: getPrimary300Color() }" :icon="['fas', 'plus']" class="mr-1" />
                      Add
                    </p>
                  </div>
                  <template v-if="item[getOCKeyName(eachTreatment)] && item[getOCKeyName(eachTreatment)].length">
                    <div
                      class="p12 br8 d-flex gap10 flex-column mb-2"
                      :style="{ border: '1px solid #E2E8F0' }"
                      v-for="treatmentDetails in item[getOCKeyName(eachTreatment)]"
                      :key="treatmentDetails.id"
                    >
                      <div class="d-flex align-items-center">
                        <div class="dot" :style="{ background: getEffectivenessColor(treatmentDetails.effectiveness) }"></div>
                        <p class="ml-1 mb-0 font16 fw700 gray900 flex-grow-1">{{ getTreamentDisplayName(eachTreatment, treatmentDetails) }}</p>
                        <font-awesome-icon
                          :icon="['fas', 'pen']"
                          class="mr-4 cp"
                          :style="{ color: getPrimary300Color() }"
                          @click="
                            handleAddTreatmentType(
                              eachTreatment,
                              'edit',
                              {
                                ...treatmentDetails,
                                treatment: [{ display_name: getTreamentDisplayName(eachTreatment, treatmentDetails) }],
                                nonmedication: { display_name: getTreamentDisplayName(eachTreatment, treatmentDetails), id: true },
                              },
                              true
                            )
                          "
                        />
                        <font-awesome-icon :icon="['fas', 'trash']" class="ml-1 cp error300" @click="handleDeleteOtherDiagnosedTreatment(eachTreatment, treatmentDetails.id)" />
                      </div>

                      <div class="d-flex align-items-center" v-if="!['Activities', 'Nutrition'].includes(eachTreatment)">
                        <p class="mb-0 mr-2 font12 gray900" style="min-width: 70px">Side Effects:</p>
                        <div class="d-flex align-items-center flex-wrap gap8" v-if="treatmentDetails.side_effect && treatmentDetails.side_effect.length">
                          <div class="br8 py-1 px-2 d-flex" :style="{ border: '1px solid #e2e8f0' }" v-for="sideEffect in treatmentDetails.side_effect" :key="sideEffect">
                            <p class="mr-3 mb-0 gray900 font12">{{ sideEffect.display_name }}</p>
                            <p class=" mb-0 fw700 font12" :style="{ color: getEffectivenessColor(sideEffect.effectiveness) }">
                              {{ getEffectiveness(sideEffect.effectiveness) }}
                            </p>
                          </div>
                        </div>
                        <template v-else> <div class="bg-gray100 br8 gray500 fw700 font12 px-2 py-1">None</div> </template>
                      </div>
                      <div class="d-flex gap8 align-items-center" v-if="['Activities'].includes(eachTreatment)">
                        <p class="mb-0 font12 gray900">Frequency</p>
                        <p class="mb-0 font12 fw700 gray900">{{ getFrequencyName(treatmentDetails.activity_freq) }}</p>
                      </div>
                      <div class="d-flex gap16 align-items-center">
                        <p class="mb-0 font12 gray900">Effectiveness</p>
                        <p class="mb-0 font12 fw700" :style="{ color: getTreatEffectivenessColor(treatmentDetails.effectiveness) }">{{ getTreatEffectiveness(treatmentDetails.effectiveness) }}</p>
                      </div>
                      <div class="d-flex gap16 align-items-center" v-if="!['Procedures'].includes(eachTreatment)">
                        <p class="mb-0 font12 gray900">From: {{ new Date(treatmentDetails.treatment_duration[0][0]).toDateString().substring(4) }}</p>
                        <p class="mb-0 font12 gray900">
                          To: {{ !treatmentDetails.treatment_duration[0][1] ? "Still Taking" : new Date(treatmentDetails.treatment_duration[0][1]).toDateString().substring(4) }}
                        </p>
                      </div>
                      <p v-else class="mb-0 font12 gray900">On: {{ new Date(treatmentDetails.treatment_duration[0][0]).toDateString().substring(4) }}</p>
                    </div>
                  </template>
                  <div class="br8 p-3 bg-gray100 text-center font16 gray400" v-else>None added</div>
                </div>

                <div class="btns-mob">
                  <span @click="() => $refs.otherSymptomedit.show('other_symptom', [], [], fetchData, item, profileData['other_symptom'])" class="edit-button">
                    <font-awesome-icon size="1x" :style="{ color: getAlphaPrimaryColor50() }" :icon="['fas', 'pen']" />
                    <span :style="{ color: getPrimaryColor() }" class="button-text">Edit</span>
                  </span>
                  <div @click="deleteClick('Other Condition', item)" class="dlt-inner">
                    <font-awesome-icon size="1x" :style="{ color: '#FF9999' }" :icon="['fas', 'trash']" />
                    Delete
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="dailog">You haven’t added other diagnosed conditions. Add them to increase your profile visibility.</div>
          </div>
        </div>

        <!-- AdditionalConditions -->

        <div id="2loop" :style="{ width: '100%' }" v-for="(cardValue, cardKey, index) in cardKeys" :key="index">
          <!-- <div v-if="cardKey === 'given_what_i_know_now'" class="symptoms"> -->
          <div v-if="cardKey === 'add_conditions'" class="symptoms">
            <div class="cont">
              <div class="header-cont">
                <span class="header"> Additional Conditions </span>
                <span
                  :style="{ background: getPrimary50Color() }"
                  class="edit-button"
                  @click="() => $refs.additionalConditionsModal.show('add_conditions', profileData['add_conditions'], [], fetchData)"
                  v-if="!cardValue"
                >
                  <font-awesome-icon size="1x" :style="{ color: getAlphaPrimaryColor50() }" :icon="['fas', 'plus']" />
                  <span :style="{ color: getPrimaryColor() }" class="button-text">Add</span>
                </span>
              </div>
              <span class="bio">(Conditions that haven’t been diagnosed by a healthcare professional)</span>
            </div>
            <div class="top" v-if="profileData['add_conditions'] && profileData['add_conditions'].length">
              <div v-for="(item, index) in additionalConditions" :key="index" class="other-condition">
                <div class="other-cond-header">
                  <span v-if="item" class="header-cond">{{ item }}</span>
                  <div class="btns">
                    <span @click="() => $refs.additionalConditionedit.show('add_conditions', profileData['add_conditions'], [], fetchData, item)" class="edit-button">
                      <font-awesome-icon size="1x" :style="{ color: getAlphaPrimaryColor50() }" :icon="['fas', 'pen']" />
                      <span :style="{ color: getPrimaryColor() }" class="button-text">Edit</span>
                    </span>
                    <div @click="deleteClick('Additional Condition', item)" class="dlt-inner">
                      <!-- <div @click="handleAddCondDel(item)" class="dlt-inner"> -->
                      <font-awesome-icon size="1x" :style="{ color: '#FF9999' }" :icon="['fas', 'trash']" />
                      Delete
                    </div>
                  </div>
                </div>

                <div class="symp-cont">
                  <span class="name">Symptoms:</span>
                  <div class="symptomsgrid">
                    <div v-for="(symptom, index) in profileData['add_conditions']" :key="index" v-if="symptom.circle_name === item" class="grid-item">
                      <div class="info-cont">
                        <span class="name"> {{ symptom.display_name }}</span>
                        <span
                          :style="{ color: getEffectivenessColor(symptom.effectiveness), background: `${getEffectivenessColor(symptom.effectiveness)}25`, 'line-height': '14px', width: 'fit-content' }"
                          class="d-flex rounded fw700 font12 py-1 px-2 justify-content-center"
                        >
                          {{ getEffectiveness(symptom.effectiveness) }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="btns-mob">
                  <span @click="() => $refs.additionalConditionedit.show('add_conditions', profileData['add_conditions'], [], fetchData, item)" class="edit-button">
                    <font-awesome-icon size="1x" :style="{ color: getAlphaPrimaryColor50() }" :icon="['fas', 'pen']" />
                    <span :style="{ color: getPrimaryColor() }" class="button-text">Edit</span>
                  </span>
                  <div @click="deleteClick('Symptom', item)" class="dlt-inner">
                    <!-- <div @click="handleAddCondDel(item)" class="dlt-inner"> -->
                    <font-awesome-icon size="1x" :style="{ color: '#FF9999' }" :icon="['fas', 'trash']" />
                    Delete
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="dailog">You haven’t added other conditions. Add them to increase your profile visibility.</div>
          </div>
        </div>

        <!-- All other conditions -->

        <div id="3loop" :style="{ width: '100%' }" v-for="(cardValue, cardKey, index) in cardKeys" :key="index">
          <!-- treaments -->

          <!-- <div v-if="cardKey === 'treatment'" class="dovemed-card">
            <div class="heading-icon">
              <div class="title d-inline-block ">
                TYPES OF TREATMENTS AND PROCEDURES
                {{ profileData[cardKey] | total }}
              </div>
              <span 
                :style="{background: getAlphaPrimaryColor() }" class="edit-button"  
                @click="$router.push({ name: 'PatientTreatments' })"
                  v-if="!cardValue"
              >
                    <font-awesome-icon
                            size="1x"
                            :style="{   color: getAlphaPrimaryColor50()}"
                            :icon="['fas', 'pen']"
                          />
                    <span :style="{ color: getPrimaryColor() }" class="button-text"> Edit</span>
              </span>
            </div>
            <div>
              <div v-if="'Medication' in groupedTreatments">
                <div
                  :style="{ 'font-size': '16px' }"
                  class="font-weight-bold mb-2"
                >
                  Medication
                </div>
                <div
                  v-if="'Medication' in groupedTreatments"
                  class="user-treatment"
                >
                  <ul>
                    <li
                      v-for="treatment in groupedTreatments.Medication"
                      :key="treatment.id"
                      class="display-symptom text-capitalize mb-2 d-flex font-weight-bold"
                    >
                      {{ treatment.treatment[0].display_name }}
                      <div class="d-flex">
                        <div
                          class="treatment-eff"
                          :style="{
                            color: getTreatEffectivenessColor(
                              treatment.effectiveness
                            ),
                            background: `${getTreatEffectivenessColor(
                              treatment.effectiveness
                            )}25`,
                            padding: '2px 5px',
                            'min-width': '100px',
                            'border-radius': '5px',
                            height: 'fit-content',
                            width: 'fit-content',
                            display: 'flex',
                            'margin-right': '10px',
                            'justify-content': 'center'
                          }"
                        >
                          {{ getTreatEffectiveness(treatment.effectiveness) }}
                        </div>
                        <span
                          @click="removeTreatment(treatment.id)"
                          class="icon  cp"
                        >
                          <font-awesome-icon
                            size="2x"
                            :style="{
                              color: '#fa5c5c',

                              transform: 'scale(0.6)',
                              'margin-left': '5px'
                            }"
                            :icon="['fas', 'trash']"
                          />
                        </span>
                      </div>
                    </li>
                  </ul>
                </div>
                <div v-else class="dailog">No Medications listed.</div>
              </div>

              <div v-if="'Procedure' in groupedTreatments">
                <div
                  :style="{ 'font-size': '16px' }"
                  class="font-weight-bold mb-2"
                >
                  Procedure
                </div>
                <div
                  v-if="'Procedure' in groupedTreatments"
                  class="user-treatment"
                >
                  <ul>
                    <li
                      v-for="treatment in groupedTreatments.Procedure"
                      :key="treatment.id"
                      class="display-symptom text-capitalize mb-2 d-flex font-weight-bold"
                    >
                      <div class="profile-sub">
                        <div>{{ treatment.treatment[0].display_name }}</div>
                        <span v-if="treatment.treatment[0].sub_type">
                          (
                          <span
                            v-for="(sub, index) in treatment.treatment[0]
                              .sub_type"
                            :key="index"
                          >
                            {{ sub }}
                          </span>
                          )
                        </span>
                      </div>
                      <div class="d-flex">
                        <div
                          class="treatment-eff"
                          :style="{
                            color: getTreatEffectivenessColor(
                              treatment.effectiveness
                            ),
                            background: `${getTreatEffectivenessColor(
                              treatment.effectiveness
                            )}25`,
                            padding: '2px 5px',
                            'min-width': '100px',
                            'border-radius': '5px',
                            height: 'fit-content',
                            width: 'fit-content',
                            display: 'flex',
                            'margin-right': '10px',
                            'justify-content': 'center'
                          }"
                        >
                          {{ getTreatEffectiveness(treatment.effectiveness) }}
                        </div>
                        <span
                          @click="removeTreatment(treatment.id)"
                          class="icon  cp"
                        >
                          <font-awesome-icon
                            size="2x"
                            :style="{
                              color: '#fa5c5c',

                              transform: 'scale(0.6)',
                              'margin-left': '5px'
                            }"
                            :icon="['fas', 'trash']"
                          />
                        </span>
                      </div>
                    </li>
                  </ul>
                </div>
                <div v-else class="dailog">No Procedures listed.</div>
              </div>

              <div v-if="'Activity' in groupedTreatments">
                <div
                  :style="{ 'font-size': '16px' }"
                  class="font-weight-bold mb-2"
                >
                  Activity
                </div>
                <div
                  v-if="'Activity' in groupedTreatments"
                  class="user-treatment"
                >
                  <ul>
                    <li
                      v-for="treatment in groupedTreatments.Activity"
                      :key="treatment.id"
                      class="display-symptom text-capitalize mb-2 d-flex font-weight-bold"
                    >
                      {{ treatment.treatment[0].display_name }}

                      <div class="d-flex">
                        <div
                          class="treatment-eff"
                          :style="{
                            color: getTreatEffectivenessColor(
                              treatment.effectiveness
                            ),
                            background: `${getTreatEffectivenessColor(
                              treatment.effectiveness
                            )}25`,
                            padding: '2px 5px',
                            'min-width': '100px',
                            height: 'fit-content',
                            'border-radius': '5px',
                            width: 'fit-content',
                            display: 'flex',
                            'margin-right': '10px',
                            'justify-content': 'center'
                          }"
                        >
                          {{ getTreatEffectiveness(treatment.effectiveness) }}
                        </div>
                        <span
                          @click="removeTreatment(treatment.id)"
                          class="icon  cp"
                        >
                          <font-awesome-icon
                            size="2x"
                            :style="{
                              color: '#fa5c5c',
                              transform: 'scale(0.6)',
                              'margin-left': '5px'
                            }"
                            :icon="['fas', 'trash']"
                          />
                        </span>
                      </div>
                    </li>
                  </ul>
                </div>
                <div v-else class="dailog">No activities listed.</div>
              </div>
            </div>
          </div> -->

          <!-- mostdays i find most_days_i_find_myself -->
          <!-- <div v-if="cardKey === 'most_days_i_find_myself'" class="symptoms">
            <div class="header-cont">
              <span class="header">Most Days I find myself</span>
              <span @click="() => $refs.editBasicTextModal.show(cardKey, profileData[cardKey])" v-if="!cardValue" :style="{ background: getPrimary50Color() }" class="edit-button">
                <font-awesome-icon size="1x" :style="{ color: getAlphaPrimaryColor50() }" :icon="['fas', 'plus']" />
                <span :style="{ color: getPrimaryColor() }" class="button-text">Add</span>
              </span>
            </div>
            <span v-if="profileData['most_days_i_find_myself']" class="textcontainer">{{ profileData["most_days_i_find_myself"] }}</span>
            <div v-else class="dailog">You haven’t responded yet.</div>
          </div> -->

          <!-- my life has changed  -->
          <!-- <div v-if="cardKey === 'My life has changed in this way'" class="symptoms">
            <div class="header-cont">
              <span class="header">{{ cardKey | humanize }}</span>
              <span @click="() => $refs.editBasicTextModal.show(cardKey, profileData[cardKey])" v-if="!cardValue" :style="{ background: getPrimary50Color() }" class="edit-button">
                <font-awesome-icon size="1x" :style="{ color: getAlphaPrimaryColor50() }" :icon="['fas', 'plus']" />
                <span :style="{ color: getPrimaryColor() }" class="button-text">Add</span>
              </span>
            </div>
            <span v-if="profileData['most_days_i_find_myself']" class="textcontainer">{{ profileData["my_life_has_changed_in_this_way"] }}</span>
            <div v-else class="dailog">You haven’t responded yet.</div>
          </div> -->

          <!-- when iam having bad day -->
          <!-- <div v-if="cardKey === 'when_im_having_a_bad_day'" class="symptoms">
            <div class="header-cont">
              <span class="header">{{ "when_im_having_a_bad_day" | humanize }}</span>
              <span @click="() => $refs.editBasicTextModal.show(cardKey, profileData[cardKey])" v-if="!cardValue" :style="{ background: getPrimary50Color() }" class="edit-button">
                <font-awesome-icon size="1x" :style="{ color: getAlphaPrimaryColor50() }" :icon="['fas', 'plus']" />
                <span :style="{ color: getPrimaryColor() }" class="button-text">Add</span>
              </span>
            </div>
            <span v-if="profileData['when_im_having_a_bad_day']" class="textcontainer">{{ profileData["when_im_having_a_bad_day"] }}</span>
            <div v-else class="dailog">You haven’t responded yet.</div>
          </div> -->

          <!--  given_what_i_know_now -->
          <!-- <div v-if="cardKey === 'given_what_i_know_now'" class="symptoms">
            <div class="header-cont">
              <span class="header">Given what I know now</span>
              <span @click="() => $refs.editBasicTextModal.show(cardKey, profileData[cardKey])" v-if="!cardValue" :style="{ background: getPrimary50Color() }" class="edit-button">
                <font-awesome-icon size="1x" :style="{ color: getAlphaPrimaryColor50() }" :icon="['fas', 'plus']" />
                <span :style="{ color: getPrimaryColor() }" class="button-text">Add</span>
              </span>
            </div>
            <span v-if="profileData['given_what_i_know_now']" class="textcontainer">{{ profileData["given_what_i_know_now"] }}</span>
            <div v-else class="dailog">You haven’t responded yet.</div>
          </div> -->

          <div v-if="['how_would_i_like_the_world_to_change', 'what_inspires_me', 'what_matters_to_me_the_most', 'my_favourite_places_to_visit'].includes(cardKey)" class="symptoms">
            <div class="header-cont">
              <span class="header">
                <!-- {{ cardKey.charAt(0).toUpperCase() + cardKey.replaceAll("_", " ").slice(1) }} -->
                {{
                  cardKey === "my_favourite_places_to_visit"
                    ? "My favorite places to visit"
                    : cardKey.charAt(0).toUpperCase() +
                      cardKey
                        .split("_")
                        .join(" ")
                        .slice(1) +
                      " ?"
                }}
              </span>
              <span @click="() => $refs.editBasicTextModal.show(cardKey, profileData[cardKey])" :style="{ background: getPrimary50Color() }" class="edit-button">
                <font-awesome-icon :style="{ color: getPrimary300Color() }" :icon="['fas', 'pen']" />
                <span :style="{ color: getPrimaryColor() }" class="button-text">Edit</span>
              </span>
            </div>
            <template v-if="profileData[cardKey]">
              <span v-if="seeMore[cardKey]" class="textcontainer">{{ profileData[cardKey] }}</span>
              <span v-else class="textcontainer">{{ profileData[cardKey].substring(0, 500) + "..." }}</span>
              <p v-if="!seeMore[cardKey]" class="cp font14 mb-0" @click="handleSeeMoreClick(cardKey)" :style="{ color: getPrimaryColor() }">See more</p>
            </template>
            <div v-else class="dailog">You haven’t responded yet.</div>
          </div>

          <!-- old design blocks -->

          <!-- <div v-if="cardKey === 'most_days_i_find_myself'" class="dovemed-card">
            <div class="heading-icon">
              <div class="title d-inline-block ">
                {{ cardKey | humanize }}
              </div>
              <span 
                :style="{background: getAlphaPrimaryColor() }" class="edit-button"  
                @click="
                  () =>
                    $refs.editBasicTextModal.show(cardKey, profileData[cardKey])
                "
                  v-if="!cardValue"
              >
                    <font-awesome-icon
                            size="1x"
                            :style="{   color: getPrimaryColor()}"
                            :icon="['fas', 'pen']"
                          />
                    <span :style="{ color: getPrimaryColor() }" class="button-text"> Edit</span>
              </span>
            </div>
            <div
              v-if="profileData[cardKey]"
              style="white-space: pre-wrap; overflow: auto; word-break: break-all"
            >
              {{ profileData["most_days_i_find_myself"] }}
            </div>
            <div v-else class="none-section">You haven’t responded yet.</div>
          </div>
          <div
            v-if="cardKey === 'my_life_has_changed_in_this_way'"
            class="dovemed-card"
          >
            <div class="heading-icon">
              <div class="title d-inline-block ">
                {{ cardKey | humanize }}
              </div>
              <span 
                :style="{background: getAlphaPrimaryColor() }" class="edit-button"  
                @click="
                  () =>
                    $refs.editBasicTextModal.show(cardKey, profileData[cardKey])
                "
                  v-if="!cardValue"
              >
                    <font-awesome-icon
                            size="1x"
                            :style="{   color: getPrimaryColor()}"
                            :icon="['fas', 'pen']"
                          />
                    <span :style="{ color: getPrimaryColor() }" class="button-text"> Edit</span>
              </span>
            </div>
            <div
              v-if="profileData[cardKey]"
              style="white-space: pre-wrap; overflow: auto; word-break: break-all"
            >
              {{ profileData["my_life_has_changed_in_this_way"] }}
            </div>
            <div v-else class="none-section">You haven’t responded yet.</div>
          </div>

          <div v-if="cardKey === 'when_im_having_a_bad_day'" class="dovemed-card">
            <div class="heading-icon">
              <div class="title d-inline-block ">
                {{ "when_i_am_having_a_bad_day" | humanize }}
              </div>
              <span 
                :style="{background: getAlphaPrimaryColor() }" class="edit-button"  
                @click="
                  () =>
                    $refs.editBasicTextModal.show(cardKey, profileData[cardKey])
                "
                  v-if="!cardValue"
              >
                    <font-awesome-icon
                            size="1x"
                            :style="{   color: getPrimaryColor()}"
                            :icon="['fas', 'pen']"
                          />
                    <span :style="{ color: getPrimaryColor() }" class="button-text"> Edit</span>
              </span>
            </div>
            <div
              v-if="profileData[cardKey]"
              style="white-space: pre-wrap; overflow: auto; word-break: break-all"
            >
              {{ profileData["when_im_having_a_bad_day"] }}
            </div>
            <div v-else class="none-section">You haven’t responded yet.</div>
          </div> -->

          <!-- <div v-if="cardKey === 'given_what_i_know_now'" class="dovemed-card">
            <div class="heading-icon">
              <div class="title d-inline-block ">
                {{ cardKey | humanize }}
              </div>
              <span
                @click="
                  () =>
                    $refs.editBasicTextModal.show(cardKey, profileData[cardKey])
                "
                v-if="!cardValue"
                class="edit-icon cp font-white "
                :style="{ background: getPrimaryColor() }"
              >
                <a-icon type="edit" class="d-flex align-items-center" />
                <div>Edit</div>
              </span>
              <span 
                :style="{background: getAlphaPrimaryColor() }" class="edit-button"  
                @click="
                  () =>
                    $refs.editBasicTextModal.show(cardKey, profileData[cardKey])
                "
                  v-if="!cardValue"
              >
                    <font-awesome-icon
                            size="1x"
                            :style="{   color: getPrimaryColor()}"
                            :icon="['fas', 'pen']"
                          />
                    <span :style="{ color: getPrimaryColor() }" class="button-text"> Edit</span>
              </span>
            </div>
            <div
              v-if="profileData[cardKey]"
              style="white-space: pre-wrap; overflow: auto; word-break: break-all"
            >
              {{ profileData["given_what_i_know_now"] }}
            </div>
            <div v-else class="none-section">You haven’t responded yet.</div>
          </div>
        </div>
        <div class="dovemed-card">
          <div class="heading-icon" :style="{ 'flex-direction': 'column' }">
            <div class="d-flex ">
              <div class="title d-inline-block ">
                {{ "additional conditions" | humanize }}
                {{ profileData["add_conditions"] | total }}
              </div>
              <span
                @click="
                  () =>
                    $refs.additionalConditionsModal.show(
                      'add_conditions',
                      profileData['add_conditions'],
                      [],
                      fetchData
                    )
                "
                class="edit-icon cp font-white "
                :style="{ background: getPrimaryColor() }"
              >
                <div>
                  <a-icon type="edit" class="d-flex align-items-center" />
                </div>
                <div>Edit</div>
              </span>
              <span 
                :style="{background: getAlphaPrimaryColor() }" class="edit-button"  
                @click="
                  () =>
                    $refs.additionalConditionsModal.show(
                      'add_conditions',
                      profileData['add_conditions'],
                      [],
                      fetchData
                    )
                "
                  v-if="!cardValue"
              >
                    <font-awesome-icon
                            size="1x"
                            :style="{   color: getPrimaryColor()}"
                            :icon="['fas', 'pen']"
                          />
                    <span :style="{ color: getPrimaryColor() }" class="button-text"> Edit</span>
              </span>
            </div>
            <div
              class="title d-inline-block "
              :style="{ color: 'rgba(51,51,51,0.38)', 'font-size': '12px' }"
            >
              (Conditions that hasn’t been diagnosed by a healthcare professional)
            </div>
          </div>

          <div v-if="profileData['add_conditions'].length > 0">
            <div
              class="d-flex display-symptom mt-2 flex-column"
              v-for="(item, index) in additionalConditions"
              :key="index"
            >
              <div v-if="item" class="d-flex flex-column align-items-start">
                <b>
                  {{ item }}
                </b>

                <div :style="{ display: 'flex', 'flex-wrap': 'wrap' }">
                  <div class="d-flex align-items-center">Symptoms :</div>
                  <div
                    v-for="(symptom, index) in profileData['add_conditions']"
                    :key="index"
                  >
                    <div
                      v-if="item === symptom.circle_name"
                      :style="{
                        color: getEffectivenessColor(symptom.effectiveness),
                        background: `${getEffectivenessColor(
                          symptom.effectiveness
                        )}25`,
                        padding: '2px 5px',
                        'min-width': '100px',
                        'border-radius': '5px',
                        width: 'fit-content',
                        display: 'flex',
                        'justify-content': 'center',
                      }"
                    >
                      <div class="pr-3" :style="{ color: '#333333' }">
                        {{ symptom.display_name }}
                      </div>
                      <div class="font-weight-bold">
                        {{ getEffectiveness(symptom.effectiveness) }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="none-section">You haven’t responded yet.</div>-->
        </div>
      </div>
      <BasicTextModal ref="editBasicTextModal" v-on:refresh="fetchData" />
      <AdditionalConditionsModal ref="additionalConditionsModal" v-on:refresh="fetchData" />
      <AdditionalConditionEdit ref="additionalConditionedit" v-on:refresh="fetchData" />
      <BasicDetailsModal ref="basicDetailsModal" v-on:refresh="fetchData" />
      <SymptomsModal ref="symptomsModal" v-on:refresh="fetchData" :forceRender="forceRender" />
      <OtherSumptomsModal ref="otherSymptomsModal" v-on:refresh="fetchData" />
      <OtherSymptomEdit ref="otherSymptomedit" v-on:refresh="fetchData" />
      <TreatmentModal ref="treatmentModal" v-on:refresh="fetchData" />

      <MedicationModal ref="MedicationModal" />
      <ActivityModal ref="ActivityModal" />
      <ComplimentaryTherapyModal ref="ComplimentaryTherapyModal" />
      <NutritionModal ref="NutritionModal" />
      <ProcedureModal ref="ProcedureModal" />

      <a-modal class="report_content" :centered="true" :width="586" v-model="showModal" :footer="null" :closable="false">
        <div class="d-flex pt12">
          <font-awesome-icon class="error500 bg-error50 rounded-circle font30 p20" :icon="['fas', 'exclamation-triangle']" />
          <div class="ml-3 flex1">
            <h4 class="mb-3 text-capitalize font24 fw700 gray700">Delete {{ deleteInfo.type }}?</h4>
            <p class="mb-0 gray500 font16">
              Are you sure you want to delete this {{ deleteInfo.type }}? <br />
              You can’t undo this action.
            </p>
            <div class="mt-5 gap24 d-flex">
              <button :style="{ border: 'none' }" class="p1224 br6 bg-gray200 fw700 font14 gray600 ml-auto" @click="() => (showModal = false)">Cancel</button>
              <button :style="{ border: 'none', background: getPrimaryColor() }" class="p1224 br6 fw700 font14 text-white" @click="deleteType">Delete</button>
            </div>
          </div>
        </div>
      </a-modal>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../../repositories/RepositoryFactory"
import BasicTextModal from "../../Modals/profile/BasicText"
import AdditionalConditionsModal from "../../Modals/profile/AdditionalConditions"
import BasicDetailsModal from "../../Modals/profile/BasicDetails"
import SymptomsModal from "../../Modals/profile/Symptoms"
import TreatmentModal from "../../Modals/AddTreatment"
import OtherSumptomsModal from "../../Modals/OtherSymptomsModal.vue"
import OtherSymptomEdit from "../../Modals/OtherSymptomEdit.vue"
import AdditionalConditionEdit from "../../Modals/profile/AdditionalConditionEdit.vue"
import { groupBy } from "lodash"
import moment from "moment"
import ComplimentaryTherapyModal from "../../Modals/dovedaily/ComplimentaryTherapy.vue"
import NutritionModal from "../../Modals/dovedaily/Nutrition.vue"
import ActivityModal from "../../Modals/dovedaily/Activity.vue"
import ProcedureModal from "../../Modals/dovedaily/Procedure.vue"
import MedicationModal from "../../Modals/dovedaily/Medication.vue"
import SimpleLoader from "../../commons/SimpleLoader.vue"

const AppRepository = RepositoryFactory.get("app")
const UserRepository = RepositoryFactory.get("user")

export default {
  name: "PatientAbout",
  props: {
    // cardKeys: Array,
    // profileData: Object
  },
  components: {
    BasicTextModal,
    AdditionalConditionsModal,
    BasicDetailsModal,
    SymptomsModal,
    TreatmentModal,
    OtherSumptomsModal,
    OtherSymptomEdit,
    AdditionalConditionEdit,
    ComplimentaryTherapyModal,
    NutritionModal,
    ActivityModal,
    ProcedureModal,
    MedicationModal,
    SimpleLoader,
  },
  data() {
    return {
      otherConditionsList: [],
      otherCondnLoading: false,
      cardKeys: null,
      load: false,
      profileData: [],
      editableData: null,
      componentReRender: 0,
      toDeleteKeys: ["id", "created_at", "updated_at", "is_deleted", "user", "story", "diagnosis_date", "user_circle", "about"],
      // test: null
      status: false,
      groupedTreatments: null,
      refresh: false,
      otherPatientConditions: [],
      additionalConditions: [],
      showModal: false,
      deleteInfo: {},
      // modalValues: [
      //   {
      //     name: "medications",
      //     id: "Medication",
      //   },
      //   {
      //     name: "activities",
      //     id: "Activity",
      //   },
      //   {
      //     name: "nutritions",
      //     id: "Nutrition",
      //   },
      //   {
      //     name: "complimentary therapies",
      //     id: "Complimentary Therapy",
      //   },
      // ],
      treatmentTypes: ["Medications", "Procedures", "Activities", "Nutrition", "Complimentary Therapy"],
      typesArray: ["what_inspires_me", "how_would_i_like_the_world_to_change", "what_matters_to_me_the_most", "my_favourite_places_to_visit"],
      seeMore: {},
    }
  },
  created() {
    console.warn("PatientAbout.vue created")
    console.log("profileData:", this.profileData)
    this.fetchData()
    this.fetchOtherCondns()
    // this.data = this.profileData
    // this.keys = this.makeKeys(this.cardKeys)

    AppRepository.getRelationShipStatusValues()
      .then(res => {
        this.$store.commit("User/setRelationshipStatusValues", { data: res.data.data })
      })
      .catch(err => {})

    AppRepository.getCurrentSituationValues()
      .then(res => {
        this.$store.commit("User/setCurrentSituationValues", { data: res.data.data })
      })
      .catch(err => {})

    this.$store.dispatch("Circle/diseaseTypes", { type: this.currentCircle.id })
  },

  mounted() {
    this.$el.scrollIntoView()
  },

  watch: {
    "profileData.other_symptom": function(newVal, oldVal) {
      let otherConditions = new Set()
      if (newVal !== oldVal) {
        newVal.map(ele => otherConditions.add(ele.circle_name))
        // otherConditions.forEach(ele => this.otherPatientConditions.push(ele));
        this.otherPatientConditions = Array.from(otherConditions)
        this.otherPatientConditions.slice(0, newVal.length)
      }
    },

    "profileData.add_conditions": function(newVal, oldVal) {
      let additionalCond = new Set()
      if (newVal !== oldVal) {
        newVal.map(ele => additionalCond.add(ele.circle_name))
        // additionalCond.forEach(ele => this.otherPatientConditions.push(ele));
        this.additionalConditions = Array.from(additionalCond)
        this.additionalConditions.slice(0, newVal.length)
      }
    },
  },

  computed: {
    getUserName() {
      return this.authUser.user.display_name ? this.authUser.user.display_name : "nodisplayname"
    },
    getDOB() {
      if (this.profileData["dob"]) {
        return moment(this.profileData["dob"].split("-"), "yyyymmdd")
          .fromNow()
          .split(" ")[0]
      }
    },
    getDiagnosisDate() {
      // let pDate = moment(this.profileData["diagnosis_date"], "yyyymmdd")
      //   .fromNow(true)
      //   .split(" ")[0]
      // console.log("time:", moment(this.profileData["diagnosis_date"], "yyyymmdd").fromNow(true))
      // console.log({ pDate })
      // if (pDate === "a") {
      //   return "1 year"
      // } else {
      //   return `${pDate} years`
      // }
      return moment(this.profileData["diagnosis_date"], "yyyymmdd").fromNow(true)
    },
    getOtherConditions() {
      if (this.profileData["other_symptom"].length) {
        let otherConditions = new Set()
        this.profileData["other_symptom"].map(ele => otherConditions.add(ele.circle_name))
        otherConditions.forEach(ele => this.otherPatientConditions2.push(ele))
        return this.otherPatientConditions2
      }
      return "Yet to be added"
    },
    getDiagnosedYear() {
      return new Date(this.profileData["diagnosis_date"]).getFullYear()
    },
  },

  methods: {
    handleSeeMoreClick(type) {
      this.seeMore = { ...this.seeMore, [type]: true }
    },
    getTreamentDisplayName(type, value) {
      switch (type.toLowerCase()) {
        case "medications":
          return value.medication_details.display_name || "Medication"
        case "procedures":
          return value.procedure_details.display_name || "Procedure"
        case "activities":
          return value.activity_details.display_name || "Activity"
        case "nutrition":
          return value.nutrition_details.display_name || "Nutrition"
        case "complimentary therapy":
          return value.complimentary_details.display_name || "Complimentary Therapy"
        default:
          return ""
      }
    },
    getOCKeyName(name) {
      switch (name.toLowerCase()) {
        case "medications":
          return "medication"
        case "procedures":
          return "procedure"
        case "activities":
          return "activity"
        case "nutrition":
          return "nutrition"
        case "complimentary therapy":
          return "complimentary"
        default:
          return ""
      }
    },
    fetchOtherCondns() {
      this.otherCondnLoading = true
      // try {
      //   const otherCondn = await UserRepository.getOtherConditions(this.authUser.user.id, this.currentCircle.id, this.authUser.user.role)
      //   this.otherConditionsList = otherCondn.data.data
      //   this.otherCondnLoading = false
      // } catch (e) {
      //   this.otherCondnLoading = false
      // }
      UserRepository.getOtherConditions(this.authUser.user.id, this.currentCircle.id, this.authUser.user.role)
        .then(otherCondn => {
          this.otherConditionsList = otherCondn.data.data
          this.otherCondnLoading = false
        })
        .catch(e => {
          this.otherCondnLoading = false
        })
    },
    async handleDeleteOtherDiagnosedTreatment(type = "", id = 0) {
      try {
        switch (type) {
          case "Procedures":
            await UserRepository.deleteOtherConditionProcedure(id)
            break
          case "Medications":
            await UserRepository.deleteOtherConditionMedication(id)
            break
          case "Activities":
            await UserRepository.deleteOtherConditionActivity(id)
            break
          case "Complimentary Therapy":
            await UserRepository.deleteOtherConditionComplimentary(id)
            break
          case "Nutrition":
            await UserRepository.deleteOtherConditionNutrition(id)
            break
          default:
            return
        }
        this.$notification.success({ message: "Success", description: "Deleted." })
        this.fetchOtherCondns()
      } catch (e) {
        this.$notification.error({ message: "Failed", description: "Deleted Failed." })
        console.log(e)
      }
    },
    handleAddTreatmentType(eachTreatment, action = "add", oldValue = {}, otherCondnId = 0) {
      switch (eachTreatment) {
        case "Procedures":
          this.$refs.ProcedureModal.show(action, oldValue, otherCondnId, this.fetchOtherCondns)
          break
        case "Medications":
          this.$refs.MedicationModal.show(action, oldValue, otherCondnId, this.fetchOtherCondns)
          break
        case "Activities":
          this.$refs.ActivityModal.show(action, oldValue, otherCondnId, this.fetchOtherCondns)
          break
        case "Complimentary Therapy":
          this.$refs.ComplimentaryTherapyModal.show(action, oldValue, otherCondnId, this.fetchOtherCondns)
          break
        case "Nutrition":
          this.$refs.NutritionModal.show(action, oldValue, otherCondnId, this.fetchOtherCondns)
          break
      }
    },
    deleteClick(type, details) {
      // this.$notification.info({ message: "WIP", description: "Delete functionality is not working currently." })
      this.showModal = true
      this.deleteInfo = { type, details }
    },
    deleteType() {
      switch (this.deleteInfo.type) {
        case "Symptom":
          this.handleSymDel(this.deleteInfo.details)
          break
        case "Other Condition":
          this.handleOtherCondDelete(this.deleteInfo.details)
          break
        case "Additional Condition":
          this.handleAddCondDel(this.deleteInfo.details)
          break
        default:
          this.$notification.error({ message: "Failed", description: "Nothing was deleted." })
          break
      }
      this.showModal = false
    },
    handleAddCondDel(circleName) {
      let oldSymptoms = []
      oldSymptoms = this.profileData["add_conditions"]
      let payload = null
      oldSymptoms = oldSymptoms.filter(function(ele) {
        return ele.circle_name != circleName
      })
      payload = { add_conditions: oldSymptoms }
      const headers = { Authorization: `Bearer ${this.authUser.user.token}` }
      const url = `${process.env.BASE_API_URL}/${this.authUser.user.role === "patient" ? "symptoms" : "caregiversymptoms"}/?user_id=${this.authUser.user.id}&circle_id=${this.currentCircle.id}`
      this.$store.dispatch("Signup/updateNormalUser", { url, payload, headers }).then(() => {
        this.fetchData()
      })
    },

    handleSymDel(symptomName) {
      let oldSymptoms = []
      UserRepository.getSymptoms(this.authUser.user, this.currentCircle.id)
        .then(res => {
          if (res.data) {
            oldSymptoms = res.data.data.circle_symptoms
          }
          let payload = null
          oldSymptoms = oldSymptoms.filter(function(ele) {
            return ele.display_name != symptomName
          })
          payload = { symptom: oldSymptoms }
          const headers = { Authorization: `Bearer ${this.authUser.user.token}` }
          const url = `${process.env.BASE_API_URL}/${this.authUser.user.role === "patient" ? "symptoms" : "caregiversymptoms"}/?user_id=${this.authUser.user.id}&circle_id=${this.currentCircle.id}`
          this.$store.dispatch("Signup/updateNormalUser", { url, payload, headers }).then(() => {
            this.fetchData()
            // this.$store.commit("Posts/setPercent", true)
          })
        })
        .catch(err => null)
    },

    async handleOtherCondDelete(OCDetails) {
      // handleOtherCondDelete(circleName) {
      // let oldSymptoms = []
      // UserRepository.getSymptoms(this.authUser.user, this.currentCircle.id)
      //   .then(res => {
      //     if (res.data) {
      //       oldSymptoms = res.data.data.other_symptoms
      //     }
      //     let payload = null
      //     oldSymptoms = oldSymptoms.filter(function(ele) {
      //       return ele.circle_name != circleName
      //     })
      //     payload = { other_symptom: oldSymptoms }
      //     const headers = { Authorization: `Bearer ${this.authUser.user.token}` }
      //     const url = `${process.env.BASE_API_URL}/${this.authUser.user.role === "patient" ? "symptoms" : "caregiversymptoms"}/?user_id=${this.authUser.user.id}&circle_id=${this.currentCircle.id}`
      //     this.$store.dispatch("Signup/updateNormalUser", { url, payload, headers }).then(() => {
      //       this.fetchData()
      //     })
      //   })
      //   .catch(err => null)
      try {
        await UserRepository.deleteOtherConditions(OCDetails.id)
        this.$notification.success({ message: "Success", description: "Deleted." })
        // this.fetchOtherCondns()
        this.otherConditionsList = this.otherConditionsList.filter(OC => OC.id !== OCDetails.id)
      } catch (e) {
        this.$notification.success({ message: "Success", description: "Delete Failed." })
        console.log(e)
      }
    },

    handleGoToConditions() {
      document.getElementById("other_conditions").scrollIntoView()
    },

    /**
     * Fetch user profile data
     */
    async fetchData() {
      try {
        // this.setAppLoaderStatus(true)
        this.fetchingData = true
        const data = await UserRepository.getAbout(this.authUser.user, this.currentCircle.id)
        this.profileData = data.data.data ? data.data.data[0] : {}
        console.log("fetchData() -> profileData:", this.profileData)
        let profileDataCopy = { ...this.profileData }
        this.toDeleteKeys.forEach(key => {
          delete profileDataCopy[key]
        })
        const keys = Object.keys(profileDataCopy)
        this.cardKeys = this.makeKeys(keys)
        // console.log("cardKeys:", this.cardKeys)
        this.typesArray.forEach(type => {
          if (this.profileData[type] && this.profileData[type].length > 500) {
            this.seeMore[type] = false
          } else {
            this.seeMore[type] = true
          }
        })
        this.status = true
        const patientTreatmentsList = this.profileData.treatment.map(ele => {
          ele.treatment[0].display_name = ele.treatment[0].display_name.toLowerCase()
          return ele
        })
        this.groupedTreatments = this.makeTreatments(patientTreatmentsList)
        this.refresh = true
        // this.setAppLoaderStatus(false)
        this.$store.commit("Posts/setPercent", true)


        this.fetchingData = false
      } catch (e) {
        console.log(e)
        this.fetchingData = false
        // this.setAppLoaderStatus(false)
      }
    },

    makeKeys(cardKeys) {
      let editableKeys = {}
      for (var key in cardKeys) {
        if (cardKeys.hasOwnProperty(key)) {
          editableKeys[cardKeys[key]] = false
        }
      }
      return editableKeys
    },

    makeTreatments(treatments) {
      const groupedTreatments = groupBy(treatments, function(treatment) {
        return treatment.treatment_type
      })
      return groupedTreatments
    },
    forceRender() {
      this.componentReRender += 1
    },
    // removeTreatment(treatmentId) {
    //   UserRepository.removeTreatment(treatmentId)
    //     .then(res => {
    //       this.fetchData()
    //       this.$notification.success({ message: "Success", description: "Treatment removed successfully." })
    //     })
    //     .catch(err => null)
    // },
    getEffectiveness(effectiveness) {
      switch (effectiveness) {
        case "0":
        case 0:
          return "Mild"
        case "50":
        case 50:
          return "Moderate"
        case "100":
        case 100:
          return "Severe"
      }
    },
    getEffectivenessColor(effectiveness) {
      switch (effectiveness) {
        case "0":
        case 0:
          return "#14DE0D"
        case "50":
        case 50:
          return "#F6B156"
        case "100":
        case 100:
          return "#FF4400"
      }
    },
    getTreatEffectivenessColor(effectiveness) {
      switch (effectiveness) {
        case "100":
        case 100:
          return "#14DE0D"
        case "50":
        case 50:
          return "#F6B156"
        case "0":
        case 0:
          return "#FF4400"
      }
    },
    getTreatEffectiveness(effectiveness) {
      switch (effectiveness) {
        case "100":
        case 100:
          return "Very Effective"
        case "50":
        case 50:
          return "Somewhat Effective"
        case "0":
        case 0:
          return "Not Effective"
      }
    },
  },

  filters: {
    humanize: function(value, capitalize = true) {
      if (!value) return ""
      if (value === "add_conditions") return "Additional Conditions "
      if (value === "when_im_having_a_bad_day") {
        return "When I am having a bad day"
      }
      return capitalize
        ? value
            .toLowerCase()
            .split("_")
            .map(e => e.toUpperCase())
            .join(" ")
        : value
            .toLowerCase()
            .split("_")
            .map(e => e.charAt(0).toUpperCase() + e.substring(1))
            .join(" ")
    },

    total: function(value, ...options) {
      if (!value) return ""
      return Array.isArray(value) ? `(${value.length})` : ""
    },
  },
}
</script>

<style lang="scss" scoped>
//new csss

.grid-cont {
  display: flex;
  // width: 757px;
  gap: 16px;
}

.textcontainer {
  // word-break: break-all;
  word-wrap: break-word;
  width: 789px;
  // height: 128px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;
  color: #647490 !important;
  // white-space: pre-line;
  white-space: pre-wrap;
  @media screen and (max-width: 700px) {
    width: 100%;
    height: inherit;
  }
}

.symp-cont {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 16px;
  // width: 757px;
  min-height: 122px;
  @media screen and (max-width: 700px) {
    width: 100%;
  }
}

.tag {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 4px 8px;
  height: 22px;
  background: #ffd7cc;
  border-radius: 4px;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: #ea3100;
}

.other-symp {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 16px;

  width: 757px;
  height: 122px;
}
.btns {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 0px;
  gap: 24px;
  width: 470px;
  height: 24px;
  @media screen and (max-width: 700px) {
    width: 100%;
    display: none;
  }
}
.btns-mob {
  display: none;
  @media screen and (max-width: 700px) {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    padding: 0px;
    gap: 24px;
    width: 100%;
    height: 24px;
  }
}

.header-cond {
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #0f1734;
  width: 100%;
}

.other-cond-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  // gap: 16px;
  height: 30px;
  justify-content: space-between;
  width: 100%;
  @media screen and (max-width: 700px) {
    height: inherit;
    width: 100%;
  }
}

.other-condition {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
  gap: 16px;
  // width: 789px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  margin-bottom: 24px;
  @media screen and (max-width: 700px) {
    width: 100%;
  }
}

.cont {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 4px;
  width: 100%;
  // width: 719px;
  height: 70px;
  @media screen and (max-width: 700px) {
    height: inherit;
  }
}

.dlt-inner {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 4px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  color: #ea3100;
}
.dlt {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 0px;
  gap: 4px;
  width: 228.5px;
  height: 24px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  color: #ea3100;
}

.grid-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px;
  gap: 48px;
  width: 369.5px;
  min-width: 311px;
  min-height: 82px;
  max-height: 106px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  @media screen and (max-width: 700px) {
    width: 100%;
    min-width: 311px;
  }
}

.symptomsgrid {
  // display: grid;
  // grid-template-columns: 1fr ;
  // padding: 0px;
  // // width: 789px;
  // // height: 180px;
  // grid-row-gap: 16px;
  // grid-column-gap: 16px;
  display: flex;
  flex-wrap: wrap;
  row-gap: 16px;
  column-gap: 16px;
  @media screen and (max-width: 700px) {
    width: 100%;
  }
}

.symptoms {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 24px;
  // width: 789px;
  margin-bottom: 80px;
}

.stry-cont {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  width: 100%;
  // gap: 80px;
  @media screen and (max-width: 700px) {
    width: 100%;
  }
}

.whitespace {
  white-space: pre-line;
}

.bio {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;
  color: #647490;
  // white-space: pre-line;
  white-space: pre-wrap;
  word-wrap: break-word;
  width: 100%;
}
.minibio {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
  width: 100%;
  // white-space: pre-line;
  // white-space: pre-wrap;
  // width: 790px;
  // height: 160px;
}

.dailog {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  gap: 16px;
  min-width: 790px;
  width: 100%;
  height: 56px;
  background: #f1f5f9;
  border-radius: 8px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #94a3b8;
  @media screen and (max-width: 700px) {
    width: 100%;
    min-width: 0px;
    text-align: center;
    height: inherit;
  }
}

.dailog1 {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  gap: 16px;
  height: 56px;
  background: #f1f5f9;
  border-radius: 8px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #94a3b8;
  width: 100%;
}
.interest {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
  width: 100%;
  // width: 790px;
  // height: 88px;
}

.intrst {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 24px;
  gap: 16px;
  width: fit-content;
  background: #f1f5f9;
  border-radius: 6px;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  color: #1e2945;
}
.intrst-cont {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.vertical-seperator {
  width: 1px;
  height: 36px;
  background: #cbd5e1;
  @media screen and (max-width: 700px) {
    display: none;
  }
}

.info-cont {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
}

.general-info {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px;
  // width: 790px;
  width: 100%;
  height: 56px;
  @media screen and (max-width: 700px) {
    width: 100%;
    height: inherit;
    flex-direction: column;
    height: inherit;
    gap: 24px;
    align-items: normal;
  }
}

.abt-2-cont {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 48px;
  width: 100%;
  height: inherit;
  margin-bottom: 80px;
  margin-top: 16px;
  @media screen and (max-width: 700px) {
    height: inherit;
    margin-bottom: 80px;
  }
}

.intro {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #000000;
  width: 100%;
  // text-transform: capitalize;
}

.name {
  font-weight: 700;
  @media screen and (max-width: 700px) {
    width: 100%;
  }
}

.edit-button {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 16px;
  gap: 4px;
  // gap: 10px;
  width: 80px;
  height: 32px;
  border-radius: 8px;
}

.button-text {
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  cursor: pointer;
}

.top {
  @media screen and (max-width: 700px) {
    width: 100%;
  }
}

.abt-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  // gap: 24px;
  width: 100%;
  // height: 538px;
  @media screen and (max-width: 700px) {
    height: inherit;
  }
}

.header-cont {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 16px;
  // min-height: 5px;
  // margin-bottom: 24px;
  @media screen and (max-width: 700px) {
    width: 100%;
    min-height: 0px;
    margin-bottom: 0px;
  }
}

.header {
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  line-height: 42px;
  color: #0f1734;
  @media screen and (max-width: 600px) {
    font-size: 24px;
  }
}

////old css
.dovemed-icon-button {
  border-radius: 50%;
  font-size: 15px;
  border: none;
  width: 20px;
  height: 20px;
}

.dovemed-card {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ccc;
  margin-bottom: 80px;

  .title {
    font-size: 18px;
    font-weight: bold;
    @media screen and (max-width: 900px) {
      max-width: 85%;
      min-width: 85%;
    }
  }
  ul {
    list-style: none; /* Remove default bullets */
    padding: 0px;
  }

  // ul li::before {
  //   content: "\2022";
  //   // color: #21CDE5;
  //   font-weight: bold;
  //   display: inline-block;
  //   width: 10px;
  //   height: 10px;
  //   margin-left: -1em;
  //   padding-right: 15px;
  // }

  .language {
    display: flex;
    margin-left: 20px;
    justify-content: space-between;
  }

  .mono-language {
    display: flex;
  }
}
.display-symptom {
  justify-content: space-between;
  padding: 16px 24px;
  background: rgba(37, 103, 237, 0.05);
  border-radius: 5px;
  font-size: 14px;
}
.treatment-eff {
  @media screen and (max-width: 1200px) {
    font-size: 10px;
  }
}
.profile-sub {
  span::after {
    content: ",";
  }
  span:last-child::after {
    content: "";
  }
}
.dot {
  width: 7px;
  height: 7px;
  border-radius: 2px;
  transform: translateY(1px);
}
</style>



// WEBPACK FOOTER //
// src/components/Users/Patient/PatientAbout.vue